import { RootState } from 'src/store';

export const selectProvider = (state: RootState) => state.auth.provider;
